import { render, staticRenderFns } from "./ContractorRIDC.vue?vue&type=template&id=376eaaf6&scoped=true&"
import script from "./ContractorRIDC.vue?vue&type=script&lang=ts&"
export * from "./ContractorRIDC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376eaaf6",
  null
  
)

export default component.exports